module.exports = __webpack_public_path__ + "img/new_58.b456dfee.jpg";